import React from 'react'
import QuoteWidgetCalculator from './components/Calculator'


const index = () => {
  return (
    <div >
        <QuoteWidgetCalculator onclose={()=>{}}/>
    </div>
  )
}

export default index